// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d7bbc700","453":"91a750a1","478":"62639b9e","637":"76203a75","974":"3878d3bb"}[chunkId] + ".chunk.js";
};